module.exports = __webpack_public_path__ + "img/VERIFICA_CEDULASMOV.bc37106d.svg";